/**
 * Los avisos de ANSES por mail, como casillas (la campana se sacó el 26-oct-2026: no se usaba). Controlado: recibe
 * las preferencias y avisa cada cambio con la lista completa nueva. Lo usan "Mis avisos" (Para
 * aprobar) y la configuración por usuario de los admins.
 */
export const COLORES_AVISO = {
    FAVORABLE: '#15803d',
    DESFAVORABLE: '#b91c1c',
    CITADO: '#a16207',
    DESAPARECIDO: '#6d28d9',
    PNC_ESTADO: '#0369a1',
};

export default function GrillaAvisosAnses({ preferencias = [], onChange, deshabilitado = false, idBase = 'aviso', compacta = false }) {
    const cambiar = (tipo, canal, valor) => {
        onChange?.(preferencias.map((p) => (p.tipo === tipo ? { ...p, [canal]: valor } : p)));
    };

    return (
        <table className={`table ${compacta ? 'table-sm mb-0' : 'mb-2'}`} style={{ fontSize: compacta ? '0.8rem' : '0.9rem' }}>
            <thead>
                <tr style={{ color: '#4b5563' }}>
                    <th style={{ fontWeight: 600 }}>Aviso</th>
                    <th className="text-center" style={{ fontWeight: 600, width: 90 }}><i className="bi bi-envelope me-1" />Mail</th>
                </tr>
            </thead>
            <tbody>
                {preferencias.map((p) => (
                    <tr key={p.tipo}>
                        <td style={{ color: COLORES_AVISO[p.tipo] || '#1e293b', fontWeight: 600 }}>{p.etiqueta || p.tipo}</td>
                        {['email'].map((canal) => (
                            <td key={canal} className="text-center">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`${idBase}-${p.tipo}-${canal}`}
                                    aria-label={`${p.etiqueta || p.tipo} por ${canal === 'inApp' ? 'campana' : 'mail'}`}
                                    checked={Boolean(p[canal])}
                                    disabled={deshabilitado}
                                    onChange={(e) => cambiar(p.tipo, canal, e.target.checked)}
                                />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
